import React, { useState, useEffect } from "react";
import DBFetch from "../../utils/dbFetch";
import getImage from "../../utils/WPQueries";
import Carousel from "../../components/elements/Carousel";
const { REACT_APP_FOCUS_ID } = process.env;

export default function Focus() {
  const [intro, setIntro] = useState(null);
  const [page, setPage] = useState(null);
    let _intro = DBFetch(process.env.REACT_APP_API + "pages?slug=home1&_embed");
    let _page = DBFetch(process.env.REACT_APP_API + "pages?parent="+REACT_APP_FOCUS_ID+"&_embed&per_page=30&date&order=asc");

  useEffect(() => {
    setIntro(_intro)
  }, [_intro])
  useEffect(() => {
    setPage(_page)
  }, [_page])
  page && console.log(page)
    return (
        <>
            <div className="focus__intro container">
                <h2>
                    Faits marquants
                    <br />
                    <span>2020</span>
                </h2>
                {intro && intro?.length > 0 && (
                    <p
                        dangerouslySetInnerHTML={{
                            __html: intro[0]?.content?.rendered,
                        }}
                    />
                )}
            </div>

            {page?.length > 0 && (
                <div className="focus__carrousel">
                    <Carousel navigation slidesPerView={1} >
                        {page.map((item, index) => {

                          const image = item?._embedded["wp:featuredmedia"][0]?.media_details?.sizes['cie_cropped']?.source_url ? item?._embedded["wp:featuredmedia"][0].media_details?.sizes['cie_cropped']?.source_url : '';
                          const image_credit = item?._embedded["wp:featuredmedia"][0] ? item?._embedded["wp:featuredmedia"][0].alt_text : '';
                            const { date, title, content, acf } = item;
                            const _date =  new Date(date);
                            const d = _date.getDate();
                            const m = _date.getMonth() + 1;
                          const y = _date.getFullYear();
                            const sousTitre = acf["sous-titre"]
                                ? "<span>" + acf["sous-titre"] + "</span><br/>"
                                : "";

                            return (
                                <div
                                    key={`fait_${index}`}
                                    className="columns w-100 is-gapless"
                                >
                                    <div className="column is-12 is-5-desktop image">
                                        <span className="date">{d + '/' + m + '/' + y}</span>
                                        {image_credit && image_credit.length > 0 && <span className="credit">©{image_credit}</span>}
                                        {image && image.length > 0 && (
                                            <img
                                                className="responsive-image"
                                                src={image}
                                                alt={
                                                    process.env
                                                        .REACT_APP_DEFAULT_ALT
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className="column is-12 is-7-desktop text">
                                        <h3
                                            dangerouslySetInnerHTML={{
                                                __html: sousTitre + title.rendered,
                                            }}
                                        />
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: content.rendered,
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>
                </div>
            )}
        </>
    );
}
